/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Status_KilledInputs */

const en_tasks_status_killed = /** @type {(inputs: Tasks_Status_KilledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Killed`)
};

const fr_tasks_status_killed = /** @type {(inputs: Tasks_Status_KilledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêtée`)
};

const ms_sg2_tasks_status_killed = /** @type {(inputs: Tasks_Status_KilledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dihentikan`)
};

/**
* | output |
* | --- |
* | "Killed" |
*
* @param {Tasks_Status_KilledInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_status_killed = /** @type {((inputs?: Tasks_Status_KilledInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Status_KilledInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_status_killed(inputs)
	if (locale === "fr") return fr_tasks_status_killed(inputs)
	return ms_sg2_tasks_status_killed(inputs)
});